import { render, staticRenderFns } from "./AdminCellRelated.vue?vue&type=template&id=f8378672&scoped=true&"
import script from "./AdminCellRelated.vue?vue&type=script&lang=js&"
export * from "./AdminCellRelated.vue?vue&type=script&lang=js&"
import style0 from "./AdminCellRelated.vue?vue&type=style&index=0&id=f8378672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8378672",
  null
  
)

export default component.exports